import React from 'react';
import styled from "styled-components";
import Skeleton from "react-loading-skeleton";

const PropertiesGridSkeleton = ({className, windowSize}) => {
    return (
        <div className={"col-md-6 mt-md-16 " + (className ?? '')}>
            <Card className="d-flex align-items-start justify-content-between">
                <Content className="ml-24 d-flex flex-column">
                    <div className="d-block d-md-flex flex-column w-100">
                        <Skeleton width={(windowSize > 0 && windowSize < 768) ? "70%" : "50%"} height={16}/>
                        <Skeleton width={(windowSize > 0 && windowSize < 768) ? "100%" : "70%"} height={16}/>
                    </div>

                    <div className="mt-auto d-flex align-items-center justify-content-between">
                        <div className="d-flex flex-column">
                            <Skeleton width={100}/>
                        </div>
                    </div>
                </Content>

                <div className="grid-view-property-image">
                    <Skeleton height="100%" width="100%"/>
                </div>
            </Card>
        </div>
    );
};

export default PropertiesGridSkeleton;

// styles

const Card = styled.div`
    border: solid 1px ${props => props.theme.gray200}; 
    padding: 16px;
    border-radius: 8px;
    
    @media (max-width: ${props => props.theme.screenXsMax}) {
        border-left: none; 
        border-right: none; 
        border-bottom: none; 
        padding: 16px 0;
        border-radius: 0;
    }
    
    .grid-view-property-image {
        width: 200px;
        height: 130px;
        min-width: 200px;
        min-height: 130px;
        max-width: 200px;
        max-height: 130px;
        
        span:first-child {
            position: relative;
            top: -3.5px;
            border-radius: 8px;
        }
        
        @media (max-width: ${props => props.theme.screenXsMax}) {
            width: 180px;
            height: 120px;
            min-width: 180px;
            min-height: 120px;
            max-width: 180px;
            max-height: 120px;
        }
    }
`;

const Content = styled.div`
    width: calc(100% - 138px);
    height: 130px;
    
    @media (max-width: ${props => props.theme.screenXsMax}) {
         width: calc(100% - 128px);
         height: 120px;
    }
`;
